import React, { useEffect, useState } from 'react';
import { fetchReportStats, ReportStats } from './reportsService';
import style from './Response.module.css';

const CARDS: { key: keyof ReportStats; label: string; color: string }[] = [
  { key: 'companies', label: 'Організації', color: '#0a8081' },
  { key: 'translators', label: 'Перекладачі', color: '#2f6fed' },
  { key: 'clients', label: 'Клієнти', color: '#7c3aed' },
  { key: 'admins', label: 'Адміністратори', color: '#db2777' },
];

const Reports: React.FC = () => {
  const [stats, setStats] = useState<ReportStats | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let active = true;
    fetchReportStats()
      .then((s) => {
        if (!active) return;
        setStats(s);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className={style.wrap}>
      <div className={style.head}>
        <h2 className={style.title}>Звіти</h2>
        <p className={style.subtitle}>Ключові показники адмін-панелі</p>
      </div>
      <div className={style.grid}>
        {CARDS.map((c) => (
          <div className={style.card} key={c.key}>
            <span className={style.cardLabel}>{c.label}</span>
            <span className={style.cardValue} style={{ color: c.color }}>
              {loading ? '…' : stats?.[c.key] ?? '—'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reports;
